import { StoreState } from '../types';
import { Epic, combineEpics } from 'redux-observable';
import { createTryActionsEpic } from './Common';
import _ from 'lodash';
import { firebaseStore } from '../firebase';
import { UPDATE_SCHOOL_INFO, SchoolOnboardAction, SchoolInfoFields } from '../actions/SchoolOnboardActions';

const schoolDoc = (schoolId: string) =>
    firebaseStore.collection('schools').doc(schoolId);

const updateSchoolInfo = async ({ schoolId, fields }: { schoolId: string, fields: SchoolInfoFields }, { auth }: StoreState) => {
    const user = auth.user;
    if (!user || !user.uid) {
        throw new Error('Tried to update school info without authenticating');
    }

    if (!schoolId) {
        throw new Error('Invalid schoolId');
    }

    let newInfo: any = {};

    if (fields.name) {
        newInfo = { ...newInfo, description: fields.name };
    }

    if (fields.activities) {
        newInfo = { ...newInfo, activities: fields.activities };
    }

    if (!_.isEmpty(newInfo)) {
        await schoolDoc(schoolId).set( { info: newInfo }, { merge: true });
    }
};

const updateSchoolInfoEpic: Epic<SchoolOnboardAction, SchoolOnboardAction, StoreState> =
    createTryActionsEpic(
        UPDATE_SCHOOL_INFO,
        (a, s) => updateSchoolInfo(a.value, s),
        (a, r) => a.value);

export default combineEpics<SchoolOnboardAction, SchoolOnboardAction, StoreState>(
    updateSchoolInfoEpic
);
